export const LOGIN_URL = `${process.env.BASE_URL}/api/auth/login`;
export const PING_ACTIVITY_CHECK_FREQUENCY = process.env
	.PING_ACTIVITY_CHECK_FREQUENCY
	? process.env.PING_ACTIVITY_CHECK_FREQUENCY
	: 300000;
export const LOGOUT_URL = `${process.env.SMART_ID_DOMAIN}/idp/startSLO.ping`;
